const { AttachState } = require('./helpers.js');
const Calendar = require('./calendar/index.js');
let moment = require('moment');

export const useKeys = AttachState(null, (state, DOM) => {
    //tab destroys the slide navigation
    DOM.addEventListener('keydown', e => {
        //disable tab
        var keyCode = e.keyCode || e.which;
        if (keyCode == 9) {
            e.preventDefault();
            return;
        }
        //trigger click
        if (keyCode == 13 || keyCode == 32) //space or enter
            e.target.click();
    });
});

export const useDisableSpace = AttachState(null, (state, DOM) => {
    DOM.addEventListener('keydown', e => {
        var keyCode = e.keyCode || e.which;
        if (keyCode == 32) { //space 
            e.preventDefault();
            return;
        }
    });
});

export const useTooltip = AttachState({
    show: false,
}, (state, DOM) => {
    state.bind('show', value => {
        DOM.parentElement.classList[value ? 'add' : 'remove']('view-tooltip');
    });

    DOM.addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        state.show = !state.show;
    });

    DOM.parentElement.querySelector('.close-tooltip-button').addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        state.show = false;
    });
});

export const useValidation = AttachState({
    valid: true
}, (state, DOM) => {
    state.bind('valid', value => {
        DOM.parentElement.classList[!value ? 'add' : 'remove']('error');
    });

    DOM.addEventListener('change', () => {
        state.valid = true;
    });
    DOM.addEventListener('keydown', () => {
        state.valid = true;
    });
});

export const useLabel = AttachState({
    label: ''
}, (state, DOM) => {
    state.bind('label', value => {
        DOM.parentElement.querySelector('label').innerText = value;
    });
});

export const useFocus = AttachState({
    focused: false
}, (state, element) => {
    state.bind('focused', value => {
        element.parentElement.classList[value ? 'add' : 'remove']('active');
    });

    element.addEventListener('focus', () => {
        state.focused = true;
    });
    element.addEventListener('blur', () => {
        if (element.value === '-1' || element.value === '' || element.value === 'Alege Model')
            state.focused = false;
    });
    element.parentElement.addEventListener('click', () => {
        state.focused = true;
        element.focus();
    });
});

export const useVisibility = AttachState({
    visible: false
}, (state, element) => {
    state.bind('visible', value => {
        element.parentElement.style.display = value ? '' : 'none';
    });
});

let calendarInstances = 0;
export const useCalendar = AttachState({
    showPopup: false,
    focused: false,
    availableDates: null,
    text: '',
    date: null,
    todaysDate: null
}, (state, DOM) => {
    calendarInstances++;
    const instance = calendarInstances;

    DOM.addEventListener('focus', () => {
        state.focused = true;
    });
    DOM.parentElement.addEventListener('click', () => {
        state.focused = true;
        DOM.focus();
    });
    DOM.parentElement.querySelector('.icon-calendar').addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();
        state.showPopup = !state.showPopup;

        if (state.showPopup)
            state.focused = true;
    });
    DOM.parentElement.querySelector('.close-tooltip-button').addEventListener('click', e => {
        e.preventDefault();
        e.stopPropagation();

        state.showPopup = false;
    });
    DOM.addEventListener('keyup', e => {
        state.text = e.target.value;
    });

    let divCalendar = DOM.parentElement.querySelector('.tooltip-content>div');
    divCalendar.id = `__calendar_${instance}`;
    divCalendar.classList.add('vanilla-calendar');
    let calendar = new Calendar({
        selector: `#__calendar_${instance}`,
        months: ['Ian', 'Feb', 'Mar', 'Apr', 'Mai', 'Iun', 'Iul', 'Aug', 'Sep', 'Oct', 'Noi', 'Dec'],
        shortWeekday: ['Du', 'Lu', 'Ma', 'Mi', 'Joi', 'Vi', 'Sa'],
        pastDates: false,
        onSelect: (data) => {
            state.valid = true;
            state.date = moment(data.date).startOf('day');
            state.showPopup = false;
        }
    });
    state.bind('todaysDate', value => {
        if (value) {
            calendar.set({ todaysDate: value.toDate() });
        } else {
            calendar.set({ todaysDate: moment().add(1, 'day').toDate() });
        }
    });
    state.bind('availableDates', value => {
        if (value && value.length > 0)
            calendar.set({ availableDates: value, availableWeekDays: [], datesFilter: true });
        else
            calendar.set({ availableDates: [], availableWeekDays: [], datesFilter: false });
    });
    state.bind('showPopup', value => {
        DOM.parentElement.classList[value ? 'add' : 'remove']('view-tooltip');
    });
    state.bind('focused', value => {
        DOM.parentElement.classList[value ? 'add' : 'remove']('active');
    });
    state.bind('text', value => {
        DOM.value = value;
        if (value.length !== 10)
            return state.date = null;
        let parts = value.split('/');
        if (parts[0].length != 2 || parts[1].length != 2 || parts[2].length != 4)
            return state.date = null;
        let date = moment(value, 'DD/MM/YYYY');
        if (!date.isValid)
            return state.date = null;

        state.date = date;
    });
    state.bind('date', value => {
        if (value && value.isValid) {
            DOM.value = value.format('DD/MM/YYYY');
        }
    });
});

export const useDisabled = AttachState({
    disabled: false
}, (state, DOM, refs) => {
    state.bind('disabled', v => {
        DOM.parentElement.classList[v ? 'add' : 'remove']('disabled');
        DOM.disabled = v ? true : false;
    });
});

export const useDropdown = AttachState({
    selected: null,
    selectedText: '', //workaround because of duplicate Postal Codes
    list: [],
    focused: false,
    valid: true,
    errorMessage: '',
    disabled: false,
    label: '',
    search: '',
    expanded: false
}, (state, DOM, refs) => {
    state.bind('disabled', v => {
        DOM.classList[v ? 'add' : 'remove']('disabled');
    });

    state.bind('valid', value => {
        DOM.classList[!value ? 'add' : 'remove']('error');
        DOM.classList[!value ? 'add' : 'remove']('view-field-error');
    });

    //#region desktop
    let desktop = DOM.querySelector('.select.desktop');
    let txtValue = desktop.querySelector('.select-input');
    let txtSearch = desktop.querySelector('input');
    let options = desktop.querySelector('ul');
    let margins = DOM.parentElement;
    while (margins && !margins.matches('.margins'))
        margins = margins.parentElement;

    state.bind('focused', v => {
        if (!refs || !refs.onSearchChange)
            desktop.parentElement.classList[v ? 'add' : 'remove']('active');
        desktop.parentElement.classList[v ? 'add' : 'remove']('valid');
    });
    state.bind('expanded', v => {
        desktop.classList[v ? 'add' : 'remove']('active');
        if (margins) { margins.classList[v ? 'add' : 'remove']('dd-active'); }
    });
    state.bind('valid', value => {
        desktop.parentElement.classList[!value ? 'add' : 'remove']('error');
    });
    state.bind('list', v => {
        options.innerHTML = '';

        for (const item of [...v]) {
            let option = document.createElement('li');
            option.dataValue = item.key;
            let span = document.createElement('span');
            span.innerText = item.value;
            span.dataValue = item.key;
            span.dataLabel = item.label;

            option.appendChild(span);
            options.appendChild(option);

            option.addEventListener('click', e => {
                e.stopPropagation();

                state.txtSearch = '';
                state.expanded = false;
                state.selected = e.target.dataValue.toString();
                state.selectedText = e.target.innerText;
                if (state.selected)
                    state.valid = true;
                if (refs && refs.onChange)
                    refs.onChange(state.selected, e.target.dataLabel);
            });
        }
        state.selected = null;
        state.selectedText = '';
    });
    state.bind('selected', v => {
        if (!v)
            txtValue.innerText = '';
        else {
            let listItem = state.list.find(x => x.key == v);
            txtValue.innerText = listItem ? ('' + listItem.value).replace('\n', ', ') : '';
        }
    });
    state.bind('selectedText', v => {
        if (v) {
            txtValue.innerText = v;
        }
    });
    state.bind('search', txtSearch);
    state.bind('search', v => {
        if (!refs || !refs.onSearchChange) {
            options.querySelectorAll('li').forEach(x => {
                x.style.display = v ? x.innerText.toLowerCase().indexOf(v.toLowerCase()) !== -1 ? 'block' : 'none' : 'block';
            });
        }
    });

    desktop.parentElement.addEventListener('click', e => {
        e.stopPropagation();
        if (state.disabled)
            return;

        state.focused = true;
        state.expanded = true;
        state.search = '';
        txtSearch.focus();
    });
    desktop.addEventListener('click', e => {
        e.stopPropagation();
        if (state.disabled)
            return;

        if (state.expanded) {
            state.expanded = false;
            state.focused = state.selected ? true : false;
            if (!state.selected)
                state.valid = false;
        } else {
            state.focused = true;
            state.expanded = true;
            state.search = '';
            txtSearch.focus();
        }
    });
    txtSearch.addEventListener('keydown', e => {
        var keyCode = e.keyCode || e.which;
        if (keyCode == 13) { // enter
            let lis = options.querySelectorAll('li');
            for (const li of lis) {
                if (li.style.display !== 'none') {
                    li.click();

                    break;
                }
            }
        }
    });
    txtSearch.addEventListener('click', e => {
        e.stopPropagation();
    });

    let lazyTimer;
    txtSearch.addEventListener('keyup', (e) => {
        if (refs && refs.onSearchChange) {
            if (lazyTimer)
                clearTimeout(lazyTimer);

            lazyTimer = setTimeout(() => {
                refs.onSearchChange(e.target.value);
            }, 200);
        }
    });

    let wrapperContent = document.querySelector('.wrapper-content');
    wrapperContent.addEventListener('click', () => {
        if (state.expanded) {
            state.expanded = false;
            state.focused = state.selected ? true : false;

            if (!state.selected)
                state.valid = false;
        }
    });
    //#endregion
});